import dayjs from "dayjs"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"
import mySqlToLocal from "./mySqlToLocal"
dayjs.extend(isSameOrAfter)

const getCurrentSession = (sessions) => 
{
  if (!sessions || sessions.length === 0) return null
  if (sessions.length === 1) return sessions[0]

  const sortedSessions = [...sessions].sort((a, b) => mySqlToLocal(a.starts_at).isBefore(mySqlToLocal(b.starts_at)) ? -1 : 1)
  const currentSession = sortedSessions.find((session) => mySqlToLocal(session.ends_at).isSameOrAfter(dayjs(), 'day'))

  return currentSession || sessions[sessions.length - 1]
}

export default getCurrentSession